import { motion } from 'framer-motion'
import './FailureScreen.css'

interface FailureScreenProps {
    error: string
    onRetry: () => void
    onContactSupport: () => void
}

export default function FailureScreen({ error, onRetry, onContactSupport }: FailureScreenProps) {
    return (
        <motion.div
            className="failure-screen glass"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
        >
            <div className="failure-icon-container">
                <div className="failure-circle">
                    <span className="failure-icon">✕</span>
                </div>
                <div className="failure-glow"></div>
            </div>

            <h2 className="failure-title">Transaction Failed</h2>
            <p className="failure-subtitle">
                We couldn't process your transaction. Please check your wallet and try again.
            </p>

            <div className="error-box">
                <span className="error-label">Error Details:</span>
                <p className="error-message">{error}</p>
            </div>

            <div className="failure-actions">
                <button className="btn btn-secondary" onClick={onContactSupport}>
                    Contact Support
                </button>
                <button className="btn btn-primary retry-btn" onClick={onRetry}>
                    Try Again
                </button>
            </div>
        </motion.div>
    )
}
